import i18n  from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

const savedLanguage = JSON.parse(localStorage.getItem('language'));

i18n 
    .use(Backend)
    // pass the i18n instance to react-i18next
    .use(initReactI18next)
    // init i18next
    .init({
        lng: savedLanguage,
        fallbackLng: "de",
        ns: [
            "appBar",
            "common",
            "dashboardPage",
            "editUserRolesActionItem",
            "employeeBaseDataPage",
            "flexTimeWizard",
            "flexTimeConfig",
            "instituteConfigurationPage",
            "holidayPage",
            "notFoundPage",
            "roles",
            "sideBar",
            "statusOverviewPage",
            "submitsPage",
            "timeKeepingPage",
            "unauthorizedPage",
            "userAccessPage",
            "userSettingsPage",
            "workRecordsPage",
            "workTimeModel",
            "instituteNotEnabledPage",
        ],
        defaultNS: "userSettingsPage",
        fallbackNS: "common",
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
